import { instance } from '@/services/avik-api-gateway'
import { ErrorRemedy } from '@/types/error-remedy'
import { AxiosResponse } from 'axios'

export function getErrorRemedies(): Promise<AxiosResponse<ErrorRemedy[]>> {
  return instance.get(`/error-remedy`)
}
